export const titleChange = (title) => {
    if (title !== null && title !== undefined) {
        return title.replace('SONY', 'Sony').replace('sony', 'Sony').replace("PLAYSTATION", "PlayStation").replace("Playstation", "PlayStation").replace("playstation", "PlayStation")
    } else {
        return title
    }
}